import $ from 'jquery';

// Delegation also covers forms inserted or replaced by the modal's AJAX response.
$(document).on('input change', 'form[data-holiday-preview-url] input, form[data-holiday-preview-url] select', function () {
  const form = $(this).closest('form');
  const field = $(this).attr('name');
  if (!['holiday[year]', 'holiday[start_date]', 'holiday[end_date]', 'holiday[hours_x_day]', 'holiday[status]'].includes(field)) return;

  clearTimeout(form.data('previewTimer'));
  const previous = form.data('previewRequest');
  if (previous) previous.abort();
  const output = form.find('.holiday-balance-preview');
  output.text(form.attr('data-preview-loading'));

  form.data('previewTimer', setTimeout(() => {
    if (!document.contains(form[0])) return;
    const holiday = {};
    ['year', 'start_date', 'end_date', 'hours_x_day', 'status'].forEach(name => {
      holiday[name] = form.find(`[name="holiday[${name}]"]`).val();
    });
    const request = $.ajax({
      url: form.attr('data-holiday-preview-url'), dataType: 'json',
      data: { holiday, holiday_id: form.attr('data-holiday-id') }
    });
    form.data('previewRequest', request);
    request.done(data => {
      if (document.contains(form[0]) && form.data('previewRequest') === request) output.html(data.html);
    }).fail((_xhr, status) => {
      if (status !== 'abort' && document.contains(form[0])) output.text(form.attr('data-preview-error'));
    });
  }, 200));
});
